// JsFromRoutes CacheKey 55e3d0753c4b1d319741a9e29ec9e87d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/calendar/invitations/:token'),
  accept: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/event_invitations/:token/accept'),
  decline: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/event_invitations/:token/decline'),
}
